import { createFileRoute } from '@tanstack/react-router';

import { getDepartmentOptions } from '@/module/Department/model/DepartmentQuery';

export const Route = createFileRoute(
  '/_auth/administration/_administration/department/_department/$departmentId/_layout',
)({
  loader: async ({ params: { departmentId }, context: { queryClient } }) => {
    const department = await queryClient.ensureQueryData(getDepartmentOptions(departmentId));

    return {
      department,
      crumb: department.name,
    };
  },
});
